import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";

@Component({
  selector: 'app-send-email-success',
  templateUrl: './send-email-success.component.html',
  styleUrls: ['./send-email-success.component.scss'],
  standalone: false
})
export class SendEmailSuccessComponent implements OnInit {

  email$!: Observable<string>;

  constructor(private router: Router,
              private store: Store<{
                saveEmailReducer: string,
              }>) {
  }

  ngOnInit(): void {
    this.email$ = this.store.select("saveEmailReducer");
    // this.store.select("saveEmailReducer").subscribe(email => console.log(email))
    // this.email = this.messageDataService.email;
  }

  returnToHomePage(): void {
    // this.router.navigate(['']);
    window.location.href = `${environment.portalHomeUrl}/driver-licensing`;
  }
}
